/**
 * Password rules — shared across every signup / reset path.
 *
 * Per Kiran 2026-05-14: "same password rule applies as user sign up"
 * to the staff welcome flow. Lifting the literal `8` out of three
 * separate call sites (customer RegisterPage, customer signup
 * adapter, staff welcome handler) so future tightening is one edit.
 *
 * Per Rule #23 (constant vs config): password length is a SECURITY
 * floor, not a tuning knob — stays code-only, NOT a runtime preference.
 * If the floor needs to change later, treat it as a code release.
 */

export const PASSWORD = {
  /** Minimum number of characters a user-supplied password must contain. */
  MINLENGTH: 8
} as const
